/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9.2186 17.9099c.293-.2929.7687-.2938 1.0616-.0009a.75.75 0 0 1 0 1.0607L5.2498 24 .2199 18.9702c-.0001-.0002.0002.0002 0 0A.75.75 0 1 1 1.28 17.909l3.2198 3.2197V7.1901c0-.0003 0 .0002 0 0 0-.4142.3358-.7508.75-.7508a.75.75 0 0 1 .75.75v13.9394l3.2188-3.2188ZM8.2498 1.5H23.25a.75.75 0 0 0 0-1.5H8.2498a.75.75 0 0 0 0 1.5Zm4.5001 6H23.25a.75.75 0 0 0 0-1.5H12.7499a.75.75 0 0 0 0 1.5ZM23.25 12h-6.0001a.75.75 0 0 0 0 1.5H23.25a.75.75 0 0 0 0-1.5Zm-1.5 7.5h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5Z"
    clipRule="evenodd"
  />,
  'SortDown'
);
